<template>
  <card-collapsable
    :headerClass="headerClass"
    dialogClass="selvaggia"
    :dialogProp="dialog"
  >
    <!-- :collapsed="collapsed" -->
    <!-- always visible -->
    <template #visible>
      <progress-countdown
        v-show="asta_settings.timeout_s && calciatoreInAsta"
        ref="timer_selvaggia"
        :time="asta_settings.timeout_s"
        @timeStep="setSelvaggiaTimeLeft"
        @timeover="timeoverSelvaggia"
        name="selvaggia"
      ></progress-countdown>
    </template>

    <!-- card-title -->
    <template #title>
      {{
        selvaggiaCannotJoinReason && !sonoVincitore
          ? selvaggiaCannotJoinReason
          : hoPassato
          ? selvaggiaPassoText
          : sonoVincitore
          ? "Migliore offerta"
          : "Fai offerta"
      }}
    </template>

    <!-- card-body -->
    <template #body>
      <calciatore-battuto
        :id="calciatoreInAsta"
        v-if="calciatoreInAsta"
        xLarge
      ></calciatore-battuto>

      <div class="text-center">
        <!-- Questo flex serve affinchè l'animazione sonoVincitore nn provochi scroll -->
        <div class="d-flex justify-center">
          <!-- migliore offerta corrente-->
          <squadra-offerta
            :offerta="migliore_offerta.offerta"
            :uid="migliore_offerta.vincitore"
            :ifNoOfferta="'Nessuna offerta'"
            :class="{ sonoVincitore }"
            variant="horizontal"
            creditiGlow
          ></squadra-offerta>
        </div>
        <!-- Non puoi alzare ulteriormente l'offerta -->
        <div
          v-if="
            !timeover &&
            running &&
            calciatoreInAsta !== null &&
            sonoVincitore &&
            creditiInsufficienti
          "
          class="pa-2"
        >
          <v-chip class="white primary--text"
            >Non puoi alzare ulteriormente l'offerta</v-chip
          >
        </div>
        <!-- pulsanti -->
        <div
          class="pa-4"
          v-else-if="
            !timeover && running && calciatoreInAsta !== null && !hoPassato
          "
        >
          <!-- Rilanci relativi -->
          <div v-if="migliore_offerta.offerta" class="d-flex justify-center">
            <template v-if="!offertaToConfirm">
              <v-btn
                v-for="incremento in rilanciRelativi"
                :key="incremento"
                rounded
                color="primary"
                class="ma-1"
                :disabled="!canRilanciareDi(incremento)"
                @click="preparaRilancio(incremento)"
              >
                +{{ incremento }}
              </v-btn>
            </template>
            <div
              v-else-if="offertaToConfirm"
              class="d-flex flex-column align-center"
            >
              <div
                v-if="offertaInsufficiente"
                class="d-flex align-center error--text"
              >
                <v-icon small left class="error--text">error</v-icon>
                Offerta ora insufficiente. Vuoi offrire
                {{ offertaToConfirm }} ?
              </div>
              <v-btn
                rounded
                color="primary"
                class="ma-1 pr-1"
                @click="confirmOfferta"
                >Confermo
                <crediti
                  class="ml-2"
                  :crediti="offertaToConfirm"
                  variant="dark"
                ></crediti>
                <v-menu offset-y left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      x-small
                      class="ml-1 white--text"
                      v-bind="attrs"
                      v-on="on"
                      @click.stop
                    >
                      <v-icon small>expand_more</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense class="selvaggia-confirm-menu">
                    <v-list-item @click="annullaOffertaToConfirm">
                      <v-list-item-icon class="mr-2">
                        <v-icon small color="navy">close</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title class="navy--text text--darken-2 font-weight-bold pr-4">
                        Annulla offerta
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-btn>
            </div>
          </div>
          <div class="d-flex justify-center">
            <!-- offerta -->
            <v-btn
              class="ma-1"
              color="primary"
              id="numpad-btn"
              rounded
              depressed
              @click="showNumpad"
            >
              Offerta
            </v-btn>
            <!-- passo -->
            <v-btn
              color="primary"
              class="ma-1"
              outlined
              rounded
              @click="setPasso(true)"
              :disabled="vincitore === user_uid"
            >
              Passo
            </v-btn>
          </div>
        </div>
        <div v-else-if="hoPassato" class="pa-2">
          <v-chip class="orange white--text">{{ selvaggiaPassoText }}</v-chip>
        </div>
        <div v-else class="pa-2">
          <v-chip class="orange white--text"
            >In attesa degli altri partecipanti...</v-chip
          >
        </div>
      </div>
    </template>

    <!-- footer -->
    <template #actions>
      <div v-if="my_squadra" class="pa-4">
        <squadra-info-panel :id_squadra="user_uid"></squadra-info-panel>
      </div>
      <div v-if="my_squadra" class="px-4 pb-4">
        <v-list
          :class="{ 'nice-scroll': !is_mobile }"
          class="recycle-scroller navy darken-2 pb-2 rounded"
        >
          <div class="text-center py-2 ">Pianificazione ruolo</div>
          <asta-consiglio></asta-consiglio>
          <asta-slot
            v-for="(slotData, slot, i) in myPlan[ruolo_abc]"
            :key="ruolo_abc + '_' + slot"
            :ruolo_abc="ruolo_abc"
            :iSlot="slot"
            :i="i"
          ></asta-slot>
        </v-list>
      </div>
    </template>
  </card-collapsable>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";
import mixins from "../../js/mixins";
import astaSelvaggiaActionsMixin from "../../js/mixins/astaSelvaggiaActionsMixin";
import * as types from "../../store/mutations-types";

import toast from "../../js/toast";
import ProgressCountdown from "../common/ProgressCountdown";
import SquadraInfoPanel from "../common/SquadraInfoPanel";
import CalciatoreBattuto from "../common/CalciatoreBattuto";
import CardCollapsable from "../common/CardCollapsable";
import SquadraOfferta from "../common/SquadraOfferta";
import AstaSlot from "../AstaSlot";
import AstaConsiglio from "../AstaConsiglio";
import Crediti from "../common/Crediti";

export default {
  name: "asta-selvaggia",
  mixins: [mixins, toast, astaSelvaggiaActionsMixin],
  components: {
    ProgressCountdown,
    SquadraInfoPanel,
    CalciatoreBattuto,
    CardCollapsable,
    SquadraOfferta,
    AstaSlot,
    AstaConsiglio,
    Crediti
  },
  data() {
    return {
      vincitorePrev: null,
      resetT: false,
      timeover: true,
    };
  },
  mounted() {
    console.log("--> AstaSelvaggia ready.");
    db.on("numpadSubmitted", this.setOffertaCustom);
    db.on("offerte", this.forzaPassoIfNoCrediti);
    db.on("status", this.handleTimer);
  },
  destroyed() {
    console.log("<-- AstaSelvaggia destroyed.");
    db.off("numpadSubmitted", this.setOffertaCustom);
    db.off("offerte", this.forzaPassoIfNoCrediti);
    db.off("status", this.handleTimer);
  },
  methods: {
    dismiss() {
      this.hideNumpad();
    },
    dismissSelvaggiaAction() {
      this.dismiss();
    },
    setSelvaggiaTimeLeft(timeLeft) {
      this.$store.commit(types.ASTA_LOCAL_TIMERS_UPD, {
        selvaggiaTimeLeft: parseInt(timeLeft),
      });
    },
    resetSelvaggiaTimeLeft() {
      this.$store.commit(types.ASTA_LOCAL_TIMERS_UPD, {
        selvaggiaTimeLeft: null,
      });
    },
    async timeoverSelvaggia() {
      this.timeover = true;
      this.vincitorePrev = this.vincitore;
      await this.wait(2000);
      if (
        this.vincitore == this.vincitorePrev &&
        this.vincitore !== this.user_uid &&
        this.vincitorePrev !== this.user_uid &&
        this.running &&
        this.squadra(this.user_uid).active
      ) {
        this.setPasso();
      }
    },
    // checkOfferta(offerta) {
    //   // if (offerta > this.maxOfferta || offerta < this.minOfferta) {
    //   //   this.error = true;
    //   //   this.processing = false;
    //   //   this.errorValue = this.value;
    //   //   this.clear();
    //   //   return;
    //   // }
    //   return false;
    // },
    startTimer() {
      this.timeover = false;
      if (this.$refs["timer_selvaggia"] === null) {
        console.log('$refs["timer_selvaggia"] è null');
      } else {
        this.$refs["timer_selvaggia"].start();
      }

      // NECESSARIO PER RITARDARE L'ASSEGNAZIONE DI resetT
      setTimeout(() => {
        this.resetT = true;
      }, 0);
    },
    stopTimer() {
      if (this.$refs["timer_selvaggia"] === null) {
        console.log('$refs["timer_selvaggia"] è null');
      } else {
        this.$refs["timer_selvaggia"].stop();
      }
      this.resetSelvaggiaTimeLeft();
    },
    resetTimer() {
      if (this.$refs["timer_selvaggia"] === null) {
        console.log('$refs["timer_selvaggia"] è null');
      } else {
        this.$refs["timer_selvaggia"].updateTimer(this.asta_settings.timeout_s);
      }
    },
    handleTimer(status) {
      if (this.calciatoreInAsta !== null) {
        switch (status) {
          case Constants.ASTA_STATUS.NOT_RUNNING:
            this.stopTimer();
            break;
          case Constants.ASTA_STATUS.RUNNING:
            this.startTimer();
            break;
        }
      }
    },
    forzaPassoIfNoCrediti() {
      // in AstaSelvaggia l'eventuale passo lo decide ogni squadra per se al momento
      if (
        this.calciatoreInAsta !== null &&
        !this.sonoVincitore &&
        this.squadra(this.user_uid).active
      ) {
        if (!this.hoPassato && this.creditiInsufficienti) {
          this.setPasso();
        }
        // let offerta = Helpers.calcoloOfferta(
        //   this.asta_info,
        //   this.squadra(this.user_uid),
        //   this.calciatore(this.calciatoreInAsta),
        //   this.migliore_offerta.offerta + 1
        // );
        // if (offerta === Constants.OFFERTA.PASSO && !this.hoPassato) {
        //   this.setPasso();
        // }
      }
    },
  },
  watch: {
    calciatoreInAsta(val, oldVal) {
      if (this.running) {
        if (val === null) {
          if (oldVal !== undefined) {
            this.stopTimer();
          }
        } else {
          this.startTimer();
        }
      }
    },
    /*vincitore: function (val, oldVal) {
        // aggiorno timer se cambia vincitore nel round
        if (oldVal != null || this.resetT) {
          this.timeover = false;
          this.resetTimer();
        }
      },*/
    offerta(val, oldVal) {
      // aggiorno timer se cambia offerta nel round
      if (oldVal != null || this.resetT) {
        this.timeover = false;
        this.resetTimer();
      }
    },
    timeover(val) {
      if (val) {
        this.hideNumpad();
      }
    },
    dialog(val) {
      if (!val) {
        this.hideNumpad();
        this.offertaToConfirm = false;
        this.offertaInsufficiente = false;
      }
    },
  },
  computed: {
    headerClass() {
      return {
        red:
          this.calciatoreInAsta &&
          this.migliore_offerta.vincitore &&
          !this.hoPassato &&
          !this.sonoVincitore,
        text:
          !this.calciatoreInAsta ||
          !this.migliore_offerta.vincitore ||
          this.hoPassato,
        accent: this.sonoVincitore,
        "white--text": true,
      };
    },
    // collapsed() {
    //   return false;
    // },
    // calciatoreInAsta() {
    //   return this.asta_round.calciatoreInAsta;
    // },
    dialog() {
      return Boolean(
        this.squadra(this.user_uid) &&
          this.squadra(this.user_uid).active &&
          this.calciatoreInAsta !== null &&
          this.calciatoreInAsta !== undefined &&
          this.running
        // && !this.creditiInsufficienti // nn voglio che si chiuda in questo caso
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.sonoVincitore {
  animation: vanishIn 0.5s;
}

.selvaggia-confirm-menu {
  .v-list-item {
    min-height: 42px;
  }
}
</style>
